<template>
  <div id="footer" class="container-fluid">
    <div class="fl-col">
      <div>
        <div class="col-xs-12 col-sm-6 col-md-6 server-wrapper">
          <div class="logo">
            <img src="@/assets/img/anteksclogg.png" alt="Antek" />
          </div>
          <div class="codeimg">
            <img src="@/assets/img/footercode2.jpg" alt="code" />
          </div>
          <p class="title">{{ $t("Scancodeandpay") }}</p>
        </div>
        <div class="col-xs-12 col-sm-6 col-md-6 server-wrapper">
          <div class="tab-div">
            <div class="col-xs-12 col-sm-6 col-md-2 server-wrapper">
              <ol>
                <a href="" class="tab-a">{{ $t("home") }}</a>
              </ol>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-2 server-wrapper">
              <ol>
                <a href="" class="tab-a">{{ $t("xmal") }}</a>
              </ol>
              <ol style="margin-top: 39px">
                <a href="" class="tab-b">{{ $t("chartership") }}</a>
              </ol>
              <ol>
                <a href="" class="tab-b">{{ $t("charterplane") }}</a>
              </ol>
              <ol>
                <a href="" class="tab-b">{{ $t("ElectronicCigarette") }}</a>
              </ol>
              <ol>
                <a href="" class="tab-b">{{ $t("EngineeringProject") }}</a>
              </ol>
              <ol>
                <a href="" class="tab-b">{{ $t("Semiconductor") }}</a>
              </ol>
              <ol>
                <a href="" class="tab-b">{{ $t("Personalbelongings") }}</a>
              </ol>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-2 server-wrapper">
              <ol>
                <a href="" class="tab-a">{{ $t("services") }}</a>
              </ol>
              <ol style="margin-top: 39px">
                <a href="" class="tab-b">{{ $t("domestic") }}</a>
              </ol>
              <ol>
                <a href="" class="tab-b">{{ $t("Shipmentagencyservicesbylandseaandair") }}</a>
              </ol>
              <ol>
                <a href="" class="tab-b">{{ $t("Bondedlogisticservice") }}</a>
              </ol>
              <ol>
                <a href="" class="tab-b">{{ $t("Supplychainservice") }}</a>
              </ol>
              <ol>
                <a href="" class="tab-b">{{ $t("WarehouseService") }}</a>
              </ol>
            </div>
            <div class="col-xs-12 col-sm-6 col-md-2 server-wrapper">
              <ol>
                <a href="" class="tab-a">{{ $t("aboutus") }}</a>
              </ol>
              <ol style="margin-top: 39px">
                <a href="" class="tab-b">{{ $t("aboutus2") }}</a>
              </ol>
              <ol>
                <a href="" class="tab-b">{{ $t("joinus") }}</a>
              </ol>
              <ol>
                <a href="" class="tab-b">{{ $t("news") }}</a>
              </ol>
              <ol>
                <a href="" class="tab-b">{{ $t("contactus") }}</a>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div class="fl-row fl-around" style="margin:20px 50px">
        <div class="fl-row bottom-context">
          <img class="icon-img" src="@/assets/img/phone.png" />
          <div style="margin-left: 25px" class="title-num">+86-0755-82326582</div>
        </div>
        <div class="fl-row bottom-context">
          <img class="icon-img" src="@/assets/img/mail.png" />
          <div style="margin-left: 25px" class="title-num">
            nick.n@anteksc.com
          </div>
        </div>
        <div class="fl-row bottom-context title-num" v-if="$i18n.locale === 'zh'">
          版权所有（C）2009-2022d（深圳）有限公司保留所有权
        </div>
        <div class="fl-row bottom-context title-num" v-else>
          {{ $t("Copyright") }}
        </div>
      </div>
      <div class="beian-wrapper">
        <span class="beian-label">备案号:</span>
        <a
          class="beian-link"
          href="https://beian.miit.gov.cn"
          target="_blank"
          rel="noopener noreferrer"
        >粤ICP备2022065670号</a>
      </div>
    </div>

    <!-- <div class="col-xs-12 col-sm-6 col-md-1 server-wrapper"></div>
    <div
      style="margin-top: 30px"
      class="col-xs-12 col-sm-6 col-md-2 server-wrapper"
    >
      <div class="fl-row bottom-context">
        <img class="icon-img" src="@/assets/img/phone.png" />
        <div style="margin-left: 25px" class="title-num">+86-0755-82326582</div>
      </div>
    </div>
    <div
      style="margin-top: 30px"
      class="col-xs-12 col-sm-6 col-md-2 server-wrapper"
    >
      <div class="fl-row bottom-context">
        <img class="icon-img" src="@/assets/img/mail.png" />
        <div style="margin-left: 25px" class="title-num">
          nick.n@anteksc.com
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-sm-6 col-md-7 server-wrapper"></div>
    <div
      style="margin-top: -20px; margin-bottom: 30px"
      class="col-xs-12 col-sm-6 col-md-5 server-wrapper"
    >
      <div class="fl-row bottom-context title-num">
        版权所有（C）2009-2022d（深圳）有限公司保留所有权
      </div>
    </div> -->
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
};
</script>
<style scoped>
#footer {
  width: 100%;
  height: 100%;
  color: #fff;
  background: #474747;
  /* overflow: hidden; */
  text-align: center;
  /* background: url("@/assets/img/bottom_bg_img.png"); */
}

.icon-img {
  position: absolute;
  width: 19px;
  height: 15px;
}

.title-num {
  font-size: 12px;
  color: #fac10a;
  font-weight: 400;
}

.bottom-context {
  text-align: left;
}

.beian-wrapper {
  padding: 14px 20px 16px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  background: rgba(0, 0, 0, 0.08);
  text-align: center;
  font-size: 12px;
  line-height: 20px;
}

.beian-label {
  margin-right: 6px;
  color: #a8a8a8;
}

.beian-link {
  color: #c8c8c8;
  font-weight: 400;
  transition: color 0.2s ease;
}

.beian-link:hover,
.beian-link:focus {
  color: #fac10a;
  text-decoration: none;
}

.beian-link:focus {
  outline: 1px solid #fac10a;
  outline-offset: 3px;
}

.logo {
  width: 256px;
  height: auto;
  margin: 50px auto 20px;
}

.logo img {
  display: block;
  width: 100%;
  height: auto;
}

.tab-a {
  color: #fff;
  font-size: 14px;
}

.tab-b {
  color: #fac10a;
  font-size: 14px;
}

.codeimg {
  width: 139px;
  height: 139px;
  margin: 10px auto 20px;
}

.codeimg img {
  display: block;
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.title {
  font-size: 12px;
  margin-bottom: 74px;
  color: #fac10a;
  font-weight: 400;
}

.tab-div {
  color: #d3d3d3;
  font-size: 14px;
  margin-top: 110px;
  text-align: left;
}

.email_wx {
  color: #d3d3d3;
  font-size: 14px;
}

.copy {
  color: #d3d3d3;
  font-size: 14px;
  margin: 50px 0 10px;
}

@media screen and (max-width: 997px) {
  #footer .fl-around {
    flex-wrap: wrap;
    gap: 16px;
  }

  .title {
    font-size: 20px;
  }

  .address_tel_fax {
    font-size: 12px;
  }

  .email_wx {
    font-size: 12px;
  }

  .copy {
    font-size: 12px;
    margin: 30px 0 10px;
  }
}
</style>

